import { createColumnHelper } from '@tanstack/react-table';

import { SKU } from 'types/sku';
import { Site } from 'types/site';

const col = createColumnHelper<SKU>();

export type SkuPackagesColumnsArgs = {
  caseSkus?: SKU[];
  itemSkus?: SKU[];
  sites?: Site[];
};

export const buildSkuPackagesColumns = ({
  caseSkus,
  itemSkus,
  sites,
}: SkuPackagesColumnsArgs) => [
  col.accessor((sku) => sku.name || '-', {
    id: 'name',
    header: 'Package Name',
    minSize: 150,
  }),
  col.accessor(
    (sku) => {
      const caseSku = caseSkus?.find((c) => c._id === (sku as any)?.caseSku);
      return caseSku?.name || '-';
    },
    {
      id: 'caseSku',
      header: 'Case SKU',
      minSize: 150,
    },
  ),
  col.accessor(
    (sku) => {
      const _itemsIds = (sku as any)?.items?.map((i: any) => i.sku);

      return (
        itemSkus
          ?.filter((i) => _itemsIds?.includes(i._id))
          ?.map((i) => i?.name)
          ?.join(', ') || '-'
      );
    },
    {
      id: 'itemsSku',
      header: 'Item SKU',
      minSize: 150,
    },
  ),
  col.accessor(
    (sku) => {
      const size = ((sku as any)?.items as any[])
        ?.map((i) => i.quantity)
        ?.reduce((acc, current) => acc + current, 0);
      return size || '-';
    },
    {
      id: 'itemCount',
      header: 'Item Count',
      minSize: 90,
      meta: { align: 'center' },
    },
  ),
  col.accessor(
    (sku) => {
      const assignedSites = sites
        ?.filter((s) => s?.packages?.includes(sku?._id))
        ?.map((s) => s?.name)
        ?.join(', ');
      return assignedSites || '-';
    },
    {
      id: 'assignedSites',
      header: 'Assigned Sites',
      minSize: 150,
    },
  ),
];
